/*
 * TanneryNYC Quick View
 * Global delegated handler — works on any page where .product-quick-view buttons render
 * (collection grid, homepage featured collections, search, related products, cart recs).
 */
if (!window.__tnwQuickViewInit) {
  window.__tnwQuickViewInit = true;

  (function() {

    function tnwParseQty(name) {
      if (!name) return null;
      var n = (name + '').trim();
      if (/^single$/i.test(n)) return { qty: 1, unit: 'unit' };
      var m;
      if (m = n.match(/^(\d+(?:\.\d+)?)[\s-]?pack$/i)) return { qty: +m[1], unit: 'pack' };
      if (m = n.match(/^(\d+(?:\.\d+)?)[\s-]?lb$/i))   return { qty: +m[1], unit: 'lb' };
      if (m = n.match(/^(\d+(?:\.\d+)?)[\s-]?ft$/i))   return { qty: +m[1], unit: 'ft' };
      return null;
    }

    function tnwFindQtyOptionKey(variants) {
      for (var i = 1; i <= 3; i++) {
        var key = 'option' + i;
        if (variants.some(function(v) { return tnwParseQty(v[key]); })) return key;
      }
      return null;
    }

    function tnwGetSavingsTiers(variants, optionKey) {
      var byQty = {};
      variants.forEach(function(v) {
        var p = tnwParseQty(v[optionKey]);
        if (!p) return;
        if (!byQty[p.qty] || v.price < byQty[p.qty].price) {
          byQty[p.qty] = { qty: p.qty, unit: p.unit, price: v.price, label: v[optionKey] };
        }
      });
      var qtys = Object.keys(byQty).map(Number).sort(function(a,b){ return a - b; });
      if (qtys.length < 2) return null;
      var base = byQty[qtys[0]];
      var basePerUnit = base.price / base.qty;
      return qtys.map(function(q) {
        var t = byQty[q];
        var perUnit = t.price / t.qty;
        var savings = Math.round((1 - perUnit / basePerUnit) * 100);
        return { qty: t.qty, unit: t.unit, label: t.label, price: t.price, savings: savings };
      });
    }

    function tnwMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function getSizedImage(src, size) {
      if (!src) return '';
      var url = typeof src === 'object' ? src.src || src : src;
      if (url.indexOf('http') !== 0) url = 'https:' + url;
      return url.replace(/(\.[^.]+)(\?.*)?$/, '_' + size + '$1');
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function escHtml(str) {
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    var qvSidebar, qvBody, qvClose, overlay;
    var currentHandle = null;
    var bodyClickBound = false;

    function ensureRefs() {
      if (!qvSidebar) qvSidebar = document.getElementById('quick-view-sidebar');
      if (!qvBody)    qvBody    = document.getElementById('quick-view-body');
      if (!qvClose)   qvClose   = document.getElementById('quick-view-close');
      if (!overlay)   overlay   = document.querySelector('.site-overlay');
      return !!qvSidebar && !!qvBody;
    }

    function openQuickView(handle) {
      if (!ensureRefs()) return;
      currentHandle = handle;
      qvSidebar.style.display = 'grid';
      requestAnimationFrame(function() { qvSidebar.classList.add('sidebar--opened'); });
      document.body.classList.add('sidebar-opened');
      loadProduct(handle);
    }

    function closeQuickView() {
      if (!ensureRefs()) return;
      qvSidebar.classList.remove('sidebar--opened');
      document.body.classList.remove('sidebar-opened');
      setTimeout(function() {
        qvSidebar.style.display = 'none';
        qvBody.innerHTML = '<div class="qv-loading"><div class="qv-skeleton-img"></div><div class="qv-skeleton-text"></div><div class="qv-skeleton-text qv-skeleton-text--short"></div></div>';
      }, 200);
    }

    function loadProduct(handle) {
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) { renderProduct(product); })
        .catch(function() { qvBody.innerHTML = '<p style="padding:20px">Failed to load product.</p>'; });
    }

    function renderProduct(product) {
      var firstVariant = product.variants[0];
      var hasMultipleVariants = product.variants.length > 1;
      var optionNames = product.options;

      var mediaItems = [];
      if (product.media && product.media.length > 0) {
        product.media.slice(0, 8).forEach(function(m) { mediaItems.push(m); });
      } else {
        product.images.slice(0, 8).forEach(function(img) { mediaItems.push({ media_type: 'image', src: img }); });
      }

      var firstMedia = mediaItems[0];
      var mainMediaHTML = '';
      if (firstMedia && (firstMedia.media_type === 'video' || firstMedia.media_type === 'external_video')) {
        var vSrc = firstMedia.sources ? firstMedia.sources[0].url : '';
        mainMediaHTML = '<video class="qv-main-video" autoplay muted loop playsinline src="' + vSrc + '"></video>';
      } else {
        var imgSrc = firstMedia ? getSizedImage(firstMedia.src || firstMedia, '600x600') : '';
        mainMediaHTML = '<img id="qv-main-img" class="qv-main-img" src="' + imgSrc + '" alt="' + escHtml(product.title) + '">';
      }

      var imagesHTML = '<div class="qv-images">';
      imagesHTML += '<div class="qv-main-image-wrap" id="qv-main-wrap">' + mainMediaHTML + '</div>';

      if (mediaItems.length > 1) {
        imagesHTML += '<div class="qv-thumbs">';
        mediaItems.forEach(function(m, i) {
          var isVideo = m.media_type === 'video' || m.media_type === 'external_video';
          var thumbSrc = isVideo ? (m.preview_image ? getSizedImage(m.preview_image.src, '120x120') : '') : getSizedImage(m.src || m, '120x120');
          var fullSrc  = isVideo ? (m.sources ? m.sources[0].url : '') : getSizedImage(m.src || m, '600x600');
          imagesHTML += '<button class="qv-thumb' + (i === 0 ? ' active' : '') + '" data-type="' + (isVideo ? 'video' : 'image') + '" data-src="' + fullSrc + '" data-thumb="' + thumbSrc + '">';
          imagesHTML += '<img src="' + thumbSrc + '" alt="">';
          if (isVideo) imagesHTML += '<span class="qv-thumb-play">▶</span>';
          imagesHTML += '</button>';
        });
        imagesHTML += '</div>';
      }
      imagesHTML += '</div>';

      var priceHTML = '';
      var firstPrice = firstVariant.price;
      var firstCompare = firstVariant.compare_at_price;
      if (firstCompare && firstCompare > firstPrice) {
        priceHTML = '<div class="qv-price"><span class="qv-price-sale">' + formatMoney(firstPrice) + '</span><span class="qv-price-compare">' + formatMoney(firstCompare) + '</span></div>';
      } else {
        priceHTML = '<div class="qv-price"><span class="qv-price-regular">' + formatMoney(firstPrice) + '</span></div>';
      }

      var variantsHTML = '';
      if (hasMultipleVariants) {
        variantsHTML = '<div class="qv-variants" data-variants=\'' + JSON.stringify(product.variants).replace(/'/g, '&#39;') + '\'>';
        optionNames.forEach(function(optName, optIndex) {
          var values = [];
          product.variants.forEach(function(v) {
            var val = v['option' + (optIndex + 1)];
            if (values.indexOf(val) === -1) values.push(val);
          });
          variantsHTML += '<div class="qv-option-group">';
          variantsHTML += '<span class="qv-option-label">' + escHtml(typeof optName === 'object' ? optName.name : optName) + '</span>';
          variantsHTML += '<div class="qv-chips" data-option-index="' + optIndex + '">';
          values.forEach(function(val, i) {
            variantsHTML += '<button type="button" class="qv-chip' + (i === 0 ? ' active' : '') + '" data-value="' + escHtml(val) + '">' + escHtml(val) + '</button>';
          });
          variantsHTML += '</div></div>';
        });
        variantsHTML += '</div>';
      }

      var qvSavingsHTML = '';
      var qvOptKey = tnwFindQtyOptionKey(product.variants);
      if (qvOptKey) {
        var qvTiers = tnwGetSavingsTiers(product.variants, qvOptKey);
        if (qvTiers && qvTiers.length > 1) {
          qvSavingsHTML = '<div class="qv-savings"><div class="qv-savings-label">Buy More, Save More</div><div class="qv-savings-tiers">';
          qvTiers.forEach(function(tier) {
            if (tier.savings <= 0) {
              qvSavingsHTML += '<div class="qv-savings-tier qv-savings-tier--base"><span class="qv-tier-label">' + tier.label + '</span><span class="qv-tier-price">' + tnwMoney(tier.price) + '</span><span class="qv-tier-note">Base</span></div>';
            } else {
              qvSavingsHTML += '<div class="qv-savings-tier"><span class="qv-tier-label">' + tier.label + '</span><span class="qv-tier-price">' + tnwMoney(tier.price) + '</span><span class="qv-tier-badge">Save ' + tier.savings + '%</span></div>';
            }
          });
          qvSavingsHTML += '</div></div>';
        }
      }

      var desc = product.description ? product.description.replace(/<[^>]*>/g, '').trim() : '';
      var descHTML = desc ? '<div class="qv-description">' + desc.substring(0, 300) + (desc.length > 300 ? '...' : '') + '</div>' : '';
      var linkHTML = '<a href="/products/' + product.handle + '" class="qv-full-link">View Full Product →</a>';

      var soldOut = product.available === false;
      var addBtnHTML = '<button type="button" class="qv-add-btn' + (soldOut ? ' qv-add-btn--soldout' : '') + '" id="qv-add-btn" data-variant-id="' + firstVariant.id + '"' + ((soldOut || hasMultipleVariants) ? ' disabled' : '') + '>';
      addBtnHTML += '<span class="qv-btn-text">' + (soldOut ? 'Sold Out' : (hasMultipleVariants ? 'Select Options' : 'Add to Cart')) + '</span></button>';

      qvBody.innerHTML = imagesHTML +
        '<div class="qv-info">' +
          '<h2 class="qv-title">' + escHtml(product.title) + '</h2>' +
          priceHTML + variantsHTML + qvSavingsHTML + descHTML + addBtnHTML + linkHTML +
        '</div>';

      qvBody.querySelectorAll('.qv-thumb').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          qvBody.querySelectorAll('.qv-thumb').forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          var wrap = document.getElementById('qv-main-wrap');
          wrap.style.opacity = '0';
          setTimeout(function() {
            if (thumb.dataset.type === 'video') {
              wrap.innerHTML = '<video class="qv-main-video" autoplay muted loop playsinline src="' + thumb.dataset.src + '"></video>';
            } else {
              wrap.innerHTML = '<img id="qv-main-img" class="qv-main-img" src="' + thumb.dataset.src + '" alt="">';
            }
            wrap.style.opacity = '1';
          }, 150);
        });
      });

      var variantsData = product.variants;
      qvBody.querySelectorAll('.qv-chips').forEach(function(group) {
        group.querySelectorAll('.qv-chip').forEach(function(chip) {
          chip.addEventListener('click', function() {
            group.querySelectorAll('.qv-chip').forEach(function(c) { c.classList.remove('active'); });
            chip.classList.add('active');
            updateSelectedVariant(variantsData);
          });
        });
      });

      var addBtn = document.getElementById('qv-add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', function() {
          if (addBtn.disabled) return;
          var variantId = parseInt(addBtn.dataset.variantId);
          var btnText = addBtn.querySelector('.qv-btn-text');
          addBtn.disabled = true;
          btnText.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
          .then(function(r) {
            if (r.ok) {
              btnText.textContent = 'Added!';
              setTimeout(function() {
                var cartSidebar = document.querySelector('[data-js-site-cart-sidebar]');
                if (cartSidebar && cartSidebar.show) cartSidebar.show();
                if (window.refreshCart) window.refreshCart();
              }, 100);
            } else { throw new Error('failed'); }
          })
          .catch(function() { btnText.textContent = 'Error'; })
          .finally(function() {
            setTimeout(function() { btnText.textContent = 'Add to Cart'; addBtn.disabled = false; }, 2000);
          });
        });
      }
    }

    function updateSelectedVariant(variants) {
      var chips = qvBody.querySelectorAll('.qv-chips');
      var selectedOptions = Array.from(chips).map(function(group) {
        var active = group.querySelector('.qv-chip.active');
        return active ? active.dataset.value : null;
      });
      var allSelected = selectedOptions.every(function(o) { return o !== null; });
      var addBtn = document.getElementById('qv-add-btn');
      var btnText = addBtn ? addBtn.querySelector('.qv-btn-text') : null;
      if (!allSelected || !addBtn) return;

      var matched = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = selectedOptions.every(function(opt, idx) { return v['option' + (idx + 1)] === opt; });
        if (match) { matched = v; break; }
      }

      if (matched) {
        addBtn.dataset.variantId = matched.id;
        addBtn.disabled = !matched.available;
        addBtn.classList.toggle('qv-add-btn--soldout', !matched.available);
        if (btnText) btnText.textContent = matched.available ? 'Add to Cart' : 'Sold Out';
        var priceEl = qvBody.querySelector('.qv-price-regular, .qv-price-sale');
        if (priceEl) priceEl.textContent = formatMoney(matched.price);
        var compareEl = qvBody.querySelector('.qv-price-compare');
        if (compareEl) {
          if (matched.compare_at_price > matched.price) { compareEl.textContent = formatMoney(matched.compare_at_price); compareEl.style.display = ''; }
          else { compareEl.style.display = 'none'; }
        }
        if (matched.featured_image && matched.featured_image.src) {
          var wrap = document.getElementById('qv-main-wrap');
          if (wrap) {
            wrap.style.opacity = '0';
            setTimeout(function() {
              wrap.innerHTML = '<img id="qv-main-img" class="qv-main-img" src="' + getSizedImage(matched.featured_image.src, '600x600') + '" alt="">';
              wrap.style.opacity = '1';
            }, 150);
          }
        }
      } else {
        addBtn.disabled = true;
        if (btnText) btnText.textContent = 'Unavailable';
      }
    }

    function bindGlobalHandlers() {
      if (bodyClickBound) return;
      bodyClickBound = true;

      document.body.addEventListener('click', function(e) {
        var btn = e.target.closest('.product-quick-view');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          openQuickView(btn.dataset.productHandle);
          return;
        }
        if (e.target.closest('#quick-view-close')) {
          closeQuickView();
          return;
        }
        var ov = e.target.closest('.site-overlay');
        if (ov && document.getElementById('quick-view-sidebar') && document.getElementById('quick-view-sidebar').classList.contains('sidebar--opened')) {
          closeQuickView();
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          var sb = document.getElementById('quick-view-sidebar');
          if (sb && sb.classList.contains('sidebar--opened')) closeQuickView();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindGlobalHandlers);
    } else {
      bindGlobalHandlers();
    }

  })();
}
